import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { ProjectSource } from '../../../../typings/enums';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { CheckboxFilterGroup } from '../../generic/Filter';
import type { ProjectSources } from '../../../../typings/enums';
import type { AnyFilter } from '../../../../shared/organizationPackages';

const SOURCE_OPTIONS = [
  { key: ProjectSource.Provided, label: 'Provided via CLI' },
  { key: ProjectSource.Autobuild, label: 'Quick import' },
  { key: ProjectSource.SBOM, label: 'SBOM import' },
  { key: ProjectSource.Container, label: 'Container' },
  { key: ProjectSource.Archive, label: 'Archive upload' },
];

type Props = {
  setFilters: (filter: Partial<AnyFilter>) => void;
};

/**
 * PackageInventoryFiltersProjectSource displays all of the possible sources for the parent project that the user can filter by.
 */
const PackageInventoryFiltersProjectSource: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const sources = useSelector(PackageInventoryStore.selectors.getFiltersProjectSources);
  //  Returns an onChange handler for our inputs
  const onSelect = (source: ProjectSources, isChecked: boolean) => {
    if (isChecked) {
      setFilters({ sources: [...sources, source] });
    } else {
      setFilters({ sources: sources.filter(s => s !== source) });
    }
  };
  return (
    <CheckboxFilterGroup
      title="Import method"
      options={SOURCE_OPTIONS}
      selectedOptions={sources}
      onSelect={onSelect as (key: string, isChecked: boolean) => void}
      testId="package-inventory-filters--project-source"
    />
  );
};

export default PackageInventoryFiltersProjectSource;
